import { render, staticRenderFns } from "./SalaryCalSteps.vue?vue&type=template&id=59e1d7c9&scoped=true&"
import script from "./SalaryCalSteps.vue?vue&type=script&lang=js&"
export * from "./SalaryCalSteps.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59e1d7c9",
  null
  
)

export default component.exports